export default __webpack_public_path__ + "static/media/close.c7e9aa2a.webp";